export const colis_columns_fr = [
  {
    name: "ID",
    width: "5%",
    align: "left",
  },

  {
    name: "UTILISATEUR",
    width: "20%",
    align: "left",
  },
  {
    name: "TITRE",
    width: "10%",
    align: "left",
  },
  {
    name: "TYPE",
    width: "10%",
    align: "left",
  },
  {
    name: "DIMENSION",
    width: "15%",
    align: "left",
  },
  {
    name: "POID",
    width: "10%",
    align: "left",
  },
  {
    name: "STATUT",
    width: "10%",
    align: "center",
  },
  {
    name: "ACTION",
    width: "15%",
    align: "center",
  },
];
export const colis_columns_en = [
  {
    name: "ID",
    width: "5%",
    align: "left",
  },

  {
    name: "USER",
    width: "20%",
    align: "left",
  },
  {
    name: "TITLE",
    width: "10%",
    align: "left",
  },
  {
    name: "TYPE",
    width: "10%",
    align: "left",
  },
  {
    name: "DIMENSION",
    width: "15%",
    align: "left",
  },
  {
    name: "WEIGHT",
    width: "10%",
    align: "left",
  },
  {
    name: "STATUS",
    width: "10%",
    align: "center",
  },
  {
    name: "ACTION",
    width: "15%",
    align: "center",
  },
];
